import { TManagerForm } from '~/modules/remote-banking-contacts/type.ts';
import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete.tsx';
import { useFormContext } from 'react-hook-form';
import { useDocumentTypes } from '~/hooks/useDocumentTypes';

export const DocumentBlockForm = () => {
  const { trigger } = useFormContext<TManagerForm>();
  const { docTypes } = useDocumentTypes();

  return (
    <>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormAutocomplete
          fullWidth
          options={docTypes}
          label="Тип документа"
          inputProps={{ placeholder: 'Оберіть тип документа' }}
          name={'person.documentInfo.documentTypeId'}
          onChange={() => {
            trigger('person.documentInfo.documentSeries');
            trigger('person.documentInfo.documentNumber');
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          name="person.documentInfo.documentSeries"
          label="Серія документа"
          placeholder="Введіть серію документа"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          name="person.documentInfo.documentNumber"
          label="Номер документа"
          placeholder="Введіть номер документа"
          inputProps={{
            maxLength: 9,
          }}
        />
      </Grid>
    </>
  );
};
